import React from 'react'
import { useEffect, useLayoutEffect } from 'react'

const isServer = typeof window === 'undefined'

// Mutating the React object seems necessary?
React.useLayoutEffect = isServer ? useEffect : useLayoutEffect

const useIsomorphicLayoutEffect = isServer ? useEffect : useLayoutEffect

export default useIsomorphicLayoutEffect
